import { render, staticRenderFns } from "./TournamentOverallRankingView.vue?vue&type=template&id=4a4e51be&"
import script from "./TournamentOverallRankingView.vue?vue&type=script&lang=js&"
export * from "./TournamentOverallRankingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports